import actions from './actions';
import LfDataService from '../../../Services/LfDataService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

export function fetchCustomerChildren() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let children; 

        dispatch(setCustomerChildrenFetching(true));

        lfDataService.customerChildren()
            .then(data => {
                children = data.children;

                dispatch(setCustomerChildren(children));
                dispatch(setCustomerChildrenFetching(false));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function updateCustomerChild(data) {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        dispatch(pageIsLoadingAction(true));
        dispatch(setCustomerChildrenFetching(true));

        lfDataService.updateCustomerChildren(data)
            .then(result => {
                dispatch(pageIsLoadingAction(false));
                dispatch(pageErrorAction('kunde inte uppdatera barn'));
                dispatch(pageHasErroredAction(true));
                dispatch(fetchCustomerChildren());
            })
            .catch(e => {
                dispatch(pageIsLoadingAction(true));
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}

export function setCustomerChildrenFetching(data) {
    return {
        type: actions.CUSTOMER_CHILDREN_FETCHING_SET,
        payload: data
    };
}
export function setCustomerChildren(data) {
    return {
        type: actions.CUSTOMER_CHILDREN_SET,
        payload: data
    };
}